import { Box, Stack } from '@mui/material';
import { keyframes } from '@mui/system';
import React from 'react';

import { colors } from '../theme/theme';

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

interface ShimmerLoaderProps {
    width?: string | number;
    height?: string | number;
    borderRadius?: string | number;
    variant?: 'line' | 'circle' | 'rect';
}

export const ShimmerLoader: React.FC<ShimmerLoaderProps> = ({
    width = '100%',
    height = 16,
    borderRadius = 8,
    variant = 'line',
}) => {
    const getShapeStyles = () => {
        switch (variant) {
            case 'circle':
                return {
                    borderRadius: '50%',
                    width: height,
                    height: height,
                };
            case 'rect':
                return {
                    borderRadius,
                    width,
                    height,
                };
            case 'line':
            default:
                return {
                    borderRadius,
                    width,
                    height,
                };
        }
    };

    return (
        <Box
            sx={{
                background: `linear-gradient(
                    90deg,
                    ${colors.greyPreset[5]} 25%,
                    ${colors.greyPreset[10]} 50%,
                    ${colors.greyPreset[5]} 75%
                )`,
                backgroundSize: '1000px 100%',
                animation: `${shimmer} 2s infinite`,
                ...getShapeStyles(),
            }}
        />
    );
};

export const MessageShimmer: React.FC = () => {
    return (
        <Stack gap={1} alignItems="flex-start" sx={{ mb: 2 }}>
            <ShimmerLoader width="70%" height={16} />
            <ShimmerLoader width="60%" height={16} />
        </Stack>
    );
};
